"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var button_group_1 = __importDefault(require("../../molecules/button-group"));
var button_1 = __importDefault(require("../button"));
var action_group_creator_1 = __importDefault(require("../../_helpers/action-group-creator"));
var pixel_calc_1 = require("../../_helpers/pixel-calc");
var widthOfButton = '36px';
var getPaddingForActions = function (actions) {
    var numberOfActions = actions.length;
    var spaceForActions = pixel_calc_1.multiply(widthOfButton, numberOfActions);
    var buffer = tokens_1.spacing.xsmall;
    var total = pixel_calc_1.add(spaceForActions, buffer);
    return total;
};
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  input,\n  textarea {\n    padding-right: ", ";\n  }\n\n  ", " {\n    position: absolute;\n    right: 4px;\n    top: 0;\n\n    ", " {\n      height: ", ";\n      margin: 0;\n    }\n  }\n"], ["\n  position: relative;\n\n  input,\n  textarea {\n    padding-right: ", ";\n  }\n\n  ", " {\n    position: absolute;\n    right: 4px;\n    top: 0;\n\n    ", " {\n      height: ", ";\n      margin: 0;\n    }\n  }\n"])), function (props) { return getPaddingForActions(props.actions); }, button_group_1.default.Element, button_1.default.Element, function (props) { return tokens_1.misc.input[props.size || 'default'].height; });
var actionOverrides = { appearance: 'link', size: 'small' };
var InputWithActions = function (props) {
    var Actions = action_group_creator_1.default(props.actions, actionOverrides);
    return (React.createElement(StyledWrapper, { actions: props.actions, size: props.size },
        props.children,
        " ",
        Actions));
};
exports.default = InputWithActions;
var templateObject_1;
//# sourceMappingURL=input-with-actions.js.map